import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src="/back40PitstopLogo.png" alt="Back40 Pitstop" className="footer-logo" />
          <p className="footer-tagline">Built for the tractor pulling community.</p>
        </div>

        <div className="footer-links">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/pull-library" className="footer-link">Pull Library</Link>
          <Link to="/privacy-terms" className="footer-link">Privacy &amp; Terms</Link>
        </div>

        <div className="footer-contact">
          <a href="mailto:info@back40e.com" className="footer-email">
            <Mail size={14} />
            info@back40e.com
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-copy">&copy; {year} Back40 Engineering. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
